import React from "react"

import {
  Alert,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
} from "../styles"
import {
  isAggregationMethod,
  type AggregationMethod,
} from "../utils/traceConstants"
import type { CustomTraceAggregationOption } from "./customTraceAggregation"

interface CustomTraceAggregationFieldProps {
  options: CustomTraceAggregationOption[]
  value: AggregationMethod
  warning: string | null
  onChange: (method: AggregationMethod) => void
}

export const CustomTraceAggregationField: React.FC<
  CustomTraceAggregationFieldProps
> = ({ options, value, warning, onChange }) => {
  const triggerId = React.useId()
  return (
    <div className={FIELD_CONTAINER_STYLES}>
      <div className={LABEL_ROW_STYLES}>
        <label
          id={`${triggerId}-label`}
          htmlFor={triggerId}
          className={LABEL_STYLES}
        >
          Aggregation Method
        </label>
      </div>
      <Select
        value={value}
        onValueChange={(nextValue) => {
          if (isAggregationMethod(nextValue)) {
            onChange(nextValue)
          }
        }}
      >
        <SelectTrigger id={triggerId} aria-labelledby={`${triggerId}-label`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem
              key={option.key}
              value={option.key}
              disabled={Boolean(option.unavailableReason)}
              description={option.unavailableReason}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {warning && (
        <Alert
          variant="warning"
          role="status"
          className="mt-2"
          data-testid="custom-trace-aggregation-warning"
        >
          {warning}
        </Alert>
      )}
    </div>
  )
}
